/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ParamedicReferral from './paramedic-referral';
import ParamedicReferralDetail from './paramedic-referral-detail';
import ParamedicReferralUpdate from './paramedic-referral-update';
import ParamedicReferralDeleteDialog from './paramedic-referral-delete-dialog';

const ParamedicReferralRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ParamedicReferral />} />
    <Route path="new" element={<ParamedicReferralUpdate />} />
    <Route path=":id">
      <Route index element={<ParamedicReferralDetail />} />
      <Route path="edit" element={<ParamedicReferralUpdate />} />
      <Route path="delete" element={<ParamedicReferralDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ParamedicReferralRoutes;
